import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑" className="w-full px-4 md:px-6 py-4">
      <div className="max-w-7xl mx-auto flex items-center flex-wrap gap-1.5 text-xs md:text-sm text-foreground-500">
        <Link to="/" className="hover:text-primary-600 cursor-pointer transition-colors whitespace-nowrap">
          首页
        </Link>
        {items.map((item, idx) => (
          <span key={idx} className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-arrow-right-s-line text-foreground-400"></i>
            {item.href ? (
              <Link to={item.href} className="hover:text-primary-600 cursor-pointer transition-colors">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-900 font-medium">{item.label}</span>
            )}
          </span>
        ))}
      </div>
    </nav>
  );
}